import { pilot } from '~/services/serviceInstances';
import { DocumentViewClauses as DocumentViewClause } from '~/types/Clause';
import { Uuid } from '~/types/Uuid';

import {
  DocumentViewClauseResponse,
  parseDocumentViewClauses,
} from '../document';

type Request = {
  tag: Uuid;
};

export const getCLMeDocumentClauses = async ({
  tag,
}: Request): Promise<DocumentViewClause[]> => {
  const response = (await pilot.get('/document/clme/provisions', {
    params: { tag },
  })) as DocumentViewClauseResponse[];

  return parseDocumentViewClauses(response);
};
